import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

/**
 * LazyLoadDirective — [appLazyLoad]
 *
 * Usa IntersectionObserver para disparar o evento (appLazyLoad) uma única vez,
 * assim que o elemento hospedeiro entra na viewport (com margem de 50px).
 *
 * Uso:
 *   <div [appLazyLoad] (appLazyLoad)="carregarDisciplinasLazy(registro)">
 */
@Directive({
  selector: '[appLazyLoad]'
})
export class LazyLoadDirective implements OnInit, OnDestroy {

  /** Emite uma vez quando o elemento entra na viewport. */
  @Output() appLazyLoad = new EventEmitter<void>();

  private observer: IntersectionObserver | null = null;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.appLazyLoad.emit();
          this.observer?.disconnect();
          this.observer = null;
        }
      },
      { rootMargin: '50px' }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}

